import { persist } from '@/helpers/persistor';

export const SET_ALL = 'tutorial/SET_ALL';
export const DISABLE = 'tutorial/DISABLE';
export const UPDATE = 'tutorial/UPDATE';

export const completeStep = (type) => (key) => ({
    type: DISABLE,
    data: { type, key }
});

export const update = (field, value) => ({
    type: UPDATE,
    data: { field, value }
});

export const setAll = (key) => (value) => ({
    type: SET_ALL,
    data: { key, value }
});

export const completeCreateStep = (key) => (dispatch, getState) => {
    dispatch(completeStep('create')(key));
    dispatch(persist('tutorial.create', getState().tutorial.create));
};
